var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"div"},[_c('div',{ref:"iframepage",staticClass:"iframepage"},[_c('nav-bar'),_c('IndexBanner'),_c('nav-list',{on:{"newList":_vm.newList,"sortShop":_vm.sortShop}}),_c('shoop-list',{ref:"son",on:{"so":_vm.so,"goLog":_vm.goLog}}),_c('back-top'),_c('back-top'),_c('goods-dialog',{ref:"sons"})],1),_c('bottom-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }